import { RasterBoolCatComponentProperties } from "../components/raster_bool_cat_component";
import { VectorLayerData } from "../components/vector_component";

export const IndonesiaCarbonStockLayer: VectorLayerData[] = [
    {
        name: 'Carbon stock 2003 [[t/ha]]',
        source: ['ind:pl2003_stok_karbon'],
        key: 'c_ton/ha',
        output: 'NumericTileGrid',
        distributed: false,
        wms: false,
        properties: {
            unit: 't',
            area: 'ha',
            type: undefined
        }
    },
    {
        name: 'Carbon stock 2023 [[t/ha]]',
        source: ['ind:pl2023_stok_karbon'],
        key: 'c_ton/ha',
        output: 'NumericTileGrid',
        distributed: false,
        wms: false,
        properties: {
            unit: 't',
            area: 'ha',
            type: undefined
        }
    }
]

export const KBAIndonesiaLayer: VectorLayerData[] = [
    {
        name: 'KBA',
        source: ['ind:KBA2023'],
        key: 'KBA_Qual',
        output: 'BooleanTileGrid',
        distributed: false,
        wms: false,
    },
    // {
    //     name: 'Sungai Line',
    //     source: ['ind:sungai_line_50K'],
    //     key: 'LCODE',
    //     output: 'BooleanTileGrid',
    //     distributed: false,
    //     wms: false
    // },
    {
        name: 'Rivers',
        source: ['ind:sungai_poly_50K'],
        key: 'LCODE',
        output: 'BooleanTileGrid',
        distributed: false,
        wms: false
    }
]

const ForestTypeValues2020 = [
    'APL',
    'HPT',
    'KSA/KPA',
    'HL'
]

const ForestTypeValues2010 = [
    'APL',
    'HPT',
    'HL',
    'TUBUH AIR',
    'HSA & KPA'
]

export const ForestTypeLayer: VectorLayerData[] = []

ForestTypeValues2020.forEach(value => 
    ForestTypeLayer.push(
        {
            name: `${value} (2020)`,
            source: ['ind:kws_hutan_6621'],
            key: `kws_hutan`,
            value: [value],
            output: 'BooleanTileGrid',
            distributed: false,
            wms: false,
        }
    )
)
ForestTypeLayer.push(
    {
        name: 'Forest Type (2020)',
        source: ['ind:kws_hutan_6621'],
        key: 'kws_hutan',
        value: ForestTypeValues2020,
        output: 'CategoricalTileGrid',
        distributed: false,
        wms: false,
    },
)

ForestTypeValues2010.forEach(value => 
    ForestTypeLayer.push(
        {
            name: `${value} (2010)`,
            source: ['ind:kws_hutan_325'],
            key: 'NEW_KWSN_',
            value: [value],
            output: 'BooleanTileGrid',
            distributed: false,
            wms: false,
        }
    )
)

ForestTypeLayer.push(
    {
        name: 'Forest Type (2010)',
        source: ['ind:kws_hutan_325'],
        key: 'NEW_KWSN_',
        value: ForestTypeValues2010,
        output: 'CategoricalTileGrid',
        distributed: false,
        wms: false,
    }
)

const englishTranslation = true;

export const LandLayoutVals : RasterBoolCatComponentProperties = {
    name: 'Land Layout',
    sources: [{name: 'Land Layout', source: 'ind:landuse_coded_10m'}],
    options: [
        {label: englishTranslation ? 'Forest' : 'Hutan', value: 1},
        {label: englishTranslation ? 'Agricultural and Plantation Land' : 'Lahan Pertanian dan Perkebunan', value: 2},
        {label: englishTranslation ? 'Wetlands' : 'Belukar', value: 3},
        {label: englishTranslation ? 'Wetlands / Swamp' : 'Belukar / Rawa', value: 4},
        {label: englishTranslation ? 'Urban and Open Land' : 'Pemukiman dan Lahan Terbuka', value: 5},
        {label: englishTranslation ? 'Water' : 'Air', value: 6},
        {label: englishTranslation ? 'Paddy Field / Ponds' : 'Sawah / Tambak', value: 7},
        {label: englishTranslation ? 'Mining' : 'Pertambangan', value: 8},
        {label: englishTranslation ? 'Plantation Forest' : 'Hutan Tanaman', value: 9}
    ]
}

export const HutanVals : RasterBoolCatComponentProperties = {
    name: 'Forest Type (2)',
    sources: [{name: 'Hutan', source: 'ind:hutan_coded'}],
    options: [
            {label: 'HL', value: 1},
            {label: 'HP', value: 2},
            {label: 'HPT', value: 3},
            {label: 'HPK', value: 4},
            {label: 'APL', value: 5},
            {label: 'KSA/KPA', value: 6}
    ]
}